export default __webpack_public_path__ + "static/media/162.298e4ec5.jpg";